import { useEffect, useRef, useState, ReactNode } from "react";
import SkeletonAbout from "./skeletonabout";

interface LazySectionProps<T> {
  apiFunc: () => Promise<T>;
  children: (data: T) => ReactNode;
}

const LazySectionAbout = <T,>({ apiFunc, children }: LazySectionProps<T>) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState<boolean>(false);
  const [data, setData] = useState<T | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return;

    apiFunc().then((res) => setData(res));
  }, [visible, apiFunc]);

  // return <div ref={ref}>{data ? children(data) : null} </div>;
  
  return (
  <div ref={ref}>
    {data ? children(data) : <SkeletonAbout height={350} />}
  </div>
);
};

export default LazySectionAbout;
